// Third-party imports
import $ from 'jquery';

export function getName() {
    return $('.flash').data('name');
}

export function show() {
    $('.flash').addClass('flash--active');
}

export function hide() {
    $('.flash').removeClass('flash--active');
}

export function content(flashMessage, name, flash_cb) {
    $('.flash').data('name', name);
    $('.flash').html(`${flashMessage}`);
    flash_cb();
}

export function clear() {
    content('', '', () => {});
}

export function isVisible() {
    return $('.flash').hasClass('flash--active');
}
